// extracted by mini-css-extract-plugin
module.exports = {"cta":"cta-module--cta--2UI_g"};